{
  "name": "bldrs",
  "version": "1.0.1493",
  "main": "src/index.jsx",
  "license": "AGPL-3.0",
  "homepage": "https://github.com/bldrs-ai/Share",
  "bugs": {
    "url": "https://github.com/bldrs-ai/Share/issues"
  },
  "scripts": {
    "build": "yarn build-conway",
    "build-conway": "yarn clean && yarn build-share-conway && yarn build-cosmos",
    "build-conway-debug": "yarn clean && yarn build-share-conway && yarn build-share-copy-wasm-conway-profile && yarn build-cosmos",
    "build-webifc": "yarn clean && yarn build-share-webifc && yarn build-cosmos",
    "build-cosmos": "shx mkdir -p docs && shx rm -rf docs/cosmos && cosmos-export --config .cosmos.config.json && shx mv cosmos-export docs/cosmos",
    "build-share": "yarn update-version && node tools/esbuild/build.js && shx mkdir -p docs/static/js && shx cp src/OPFS/OPFS.worker.js docs/ && shx cp src/net/github/Cache.js docs/ && yarn build-share-copy-wasm-conway-MT",
    "build-share-conway": "run-script-os",
    "build-share-conway:win32": "set USE_WEBIFC_SHIM=true&& yarn build-share",
    "build-share-conway:linux:darwin": "USE_WEBIFC_SHIM=true yarn build-share",
    "build-share-webifc": "run-script-os",
    "build-share-webifc:win32": "set USE_WEBIFC_SHIM=false&& yarn build-share && yarn build-share-copy-wasm-webifc",
    "build-share-webifc:linux:darwin": "USE_WEBIFC_SHIM=false yarn build-share && yarn build-share-copy-wasm-webifc",
    "build-share-copy-wasm-webifc": "shx cp node_modules/web-ifc/*.wasm docs/static/js",
    "build-share-copy-wasm-conway-MT": "shx cp node_modules/@bldrs-ai/conway/compiled/dependencies/conway-geom/Dist/* docs/static/js",
    "build-share-copy-wasm-conway-profile": "shx cp node_modules/@bldrs-ai/conway-web-ifc-adapter/node_modules/@bldrs-ai/conway/compiled/dependencies/conway-geom/Dist/* docs/static/js",
    "build-share-analyze": "ANALYZE=true node tools/esbuild/build.js",
    "clean": "shx rm -rf docs",
    "cy": "cypress run --browser chrome",
    "cy-build": "yarn clean && SHARE_CONFIG=cypress MINIFY=false yarn build-share-conway",
    "cy-headed": "cypress run --headed --browser chrome --no-exit",
    "cy-headed-spec": "cypress run --headed --browser chrome --no-exit --spec",
    "cy-parallel": "time ./cypress/e2e/parallel.sh",
    "cy-percy": "./tools/cy-percy.sh",
    "cy-spec": "cypress run --browser chrome --spec",
    "deps-graph": "npx dependency-cruiser src --include-only 'jsx?' --config --output-type dot | dot -T svg > deps.svg",
    "husky-init": "husky install",
    "lint": "yarn lint-src && yarn lint-tools",
    "lint-src": "yarn eslint src && yarn typecheck",
    "typecheck": "tsc -p tools/tsconfig.json",
    "lint-tools": "yarn eslint cypress tools",
    "precommit": "yarn lint && yarn test",
    "serve-https": "run-script-os",
    "serve-https:win32": "set SHARE_CONFIG=dev && set serveHttps=true && yarn serve-share-conway",
    "serve-https:linux:darwin": "SHARE_CONFIG=dev serveHttps=true yarn serve-share-conway",
    "serve": "run-script-os",
    "serve:win32": "set SHARE_CONFIG=dev && set serveHttps=false && yarn serve-share-conway",
    "serve:linux:darwin": "SHARE_CONFIG=dev serveHttps=false yarn serve-share-conway",
    "serve-prod-https": "run-script-os",
    "serve-prod-https:win32": "set SHARE_CONFIG=prod && set serveHttps=true && yarn serve-share-conway",
    "serve-prod-https:linux:darwin": "SHARE_CONFIG=prod serveHttps=true yarn serve-share-conway",
    "serve-prod": "run-script-os",
    "serve-prod:win32": "set SHARE_CONFIG=prod && set serveHttps=false && yarn serve-share-conway",
    "serve-prod:linux:darwin": "SHARE_CONFIG=prod serveHttps=false yarn serve-share-conway",
    "serve-cosmos": "cosmos --config .cosmos.config.json",
    "serve-share-conway": "run-script-os",
    "serve-share-conway:win32": "yarn build-share-conway && set USE_WEBIFC_SHIM=true&& node tools/esbuild/serve.js",
    "serve-share-conway:linux:darwin": "yarn build-share-conway && USE_WEBIFC_SHIM=true node tools/esbuild/serve.js",
    "serve-share-webifc": "run-script-os",
    "serve-share-webifc:win32": "yarn build-share-webifc && set USE_WEBIFC_SHIM=false&& node tools/esbuild/serve.js",
    "serve-share-webifc:linux:darwin": "yarn build-share-webifc && USE_WEBIFC_SHIM=false node tools/esbuild/serve.js",
    "test": "yarn test-tools && yarn test-src",
    "test-src": "jest --config tools/jest/jest.config.js",
    "test-tools": "NO_LOG=true yarn node --experimental-vm-modules $(yarn bin jest) --config tools/jest/jest-tools.config.js",
    "update-version": "./scripts/updateVersion.mjs"
  },
  "dependencies": {
    "@auth0/auth0-react": "2.0.0",
    "@babel/core": "7.18.10",
    "@babel/eslint-parser": "7.18.9",
    "@babel/plugin-syntax-import-assertions": "7.18.6",
    "@babel/preset-env": "7.18.10",
    "@babel/preset-react": "7.18.6",
    "@bldrs-ai/conway-web-ifc-adapter": "0.23.940-2",
    "@bldrs-ai/ifclib": "5.3.3",
    "@emotion/react": "11.10.0",
    "@emotion/styled": "11.10.0",
    "@fontsource/roboto": "5.1.0",
    "@mui/icons-material": "5.16.8",
    "@mui/lab": "5.0.0-alpha.95",
    "@mui/material": "5.16.8",
    "@mui/styled-engine": "5.16.8",
    "@mui/styles": "5.16.8",
    "@octokit/rest": "20.1.1",
    "@sentry/react": "9.5.0",
    "@sentry/serverless": "^7.120.3",
    "@stripe/react-stripe-js": "^3.1.1",
    "@stripe/stripe-js": "^5.6.0",
    "@svgr/core": "8.1.0",
    "@svgr/plugin-jsx": "8.1.0",
    "@svgr/webpack": "8.1.0",
    "axios": "1.6.7",
    "babel-loader": "8.3.0",
    "clsx": "1.2.1",
    "cypress-react-router": "2.0.1",
    "esbuild": "0.19.5",
    "esbuild-copy-static-files": "0.1.0",
    "esbuild-plugin-progress": "1.0.1",
    "esbuild-plugin-svgr": "2.0.0",
    "eslint-plugin-react-compiler": "19.0.0-beta-df7b47d-20241124",
    "html-webpack-plugin": "5.5.3",
    "js-cookie": "3.0.5",
    "jwt-decode": "^4.0.0",
    "material-ui-popup-state": "5.0.4",
    "matrix-widget-api": "1.13.1",
    "msw": "0.47.4",
    "normalize.css": "8.0.1",
    "postprocessing": "6.29.3",
    "prop-types": "15.8.1",
    "react": "18.2.0",
    "react-cosmos": "6.0.0-beta.6",
    "react-cosmos-plugin-webpack": "6.0.0-beta.6",
    "react-dom": "18.2.0",
    "react-feature-flags": "1.0.0",
    "react-helmet-async": "1.3.0",
    "react-markdown": "8.0.3",
    "react-qr-code": "2.0.12",
    "react-router-dom": "6.3.0",
    "react-window": "1.8.10",
    "remark-gfm": "3.0.1",
    "run-script-os": "1.1.6",
    "shx": "0.3.4",
    "stripe": "^17.6.0",
    "three": "0.135.0",
    "typescript": "4.9.4",
    "use-double-tap": "1.3.4",
    "web-ifc-viewer": "./web-ifc-viewer-1.0.209-bldrs-7.tgz",
    "web-vitals": "2.1.4",
    "webpack": "5.89.0",
    "zustand": "4.0.0"
  },
  "devDependencies": {
    "@alex_neo/jest-expect-message": "1.0.5",
    "@mui/types": "7.2.3",
    "@pablo-mayrgundter/cookies.js": "1.1.0",
    "@percy/cli": "1.28.2",
    "@percy/cypress": "3.1.2",
    "@testing-library/cypress": "10.0.1",
    "@testing-library/dom": "8.19.1",
    "@testing-library/jest-dom": "5.16.5",
    "@testing-library/react": "13.4.0",
    "@tsconfig/recommended": "1.0.1",
    "@types/react": "18.0.26",
    "@types/react-dom": "18.0.9",
    "@types/three": "0.146.0",
    "babel-jest": "28.1.3",
    "cypress": "13.6.6",
    "cypress-real-events": "1.10.3",
    "eslint": "8.22.0",
    "eslint-config-google": "0.14.0",
    "eslint-plugin-cypress": "2.12.1",
    "eslint-plugin-import": "2.26.0",
    "eslint-plugin-jest-dom": "4.0.3",
    "eslint-plugin-jsdoc": "51.3.4",
    "eslint-plugin-jsx-a11y": "6.6.1",
    "eslint-plugin-react": "7.30.1",
    "eslint-plugin-react-hooks": "4.6.0",
    "eslint-plugin-testing-library": "5.9.1",
    "husky": "8.0.1",
    "identity-obj-proxy": "3.0.0",
    "jest": "29.3.1",
    "jest-environment-jsdom": "29.3.1",
    "jsdom": "20.0.3",
    "node-fetch": "2"
  },
  "engines": {
    "node": ">=20"
  },
  "msw": {
    "workerDirectory": "public"
  }
}
